import { render } from "./CaptainsToolsSettings.vue?vue&type=template&id=630cd73f"
import script from "./CaptainsToolsSettings.vue?vue&type=script&lang=js"
export * from "./CaptainsToolsSettings.vue?vue&type=script&lang=js"
script.render = render

export default script